import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import LanguageContext from '../contexts/LanguageContext';
import { getTranslation } from '../services/languageService';
import Markdown from '../components/Markdown';
import './Privacy.scss';

const Privacy = () => {
  const { language } = useContext(LanguageContext);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  const sections = [
    'introduction',
    'dataCollection',
    'dataUsage',
    'dataSharing',
    'dataSecurity',
    'dataRetention',
    'userRights',
    'childrenPrivacy',
    'internationalTransfers',
    'policyChanges',
    'contact'
  ];

  return (
    <motion.div
      className="privacy"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <section className="section">
        <div className="container">
          <div className="privacy-content">
            <motion.h1 className="page-title text-center" variants={itemVariants}>
              {getTranslation('privacy.title', language)}
            </motion.h1>

            <motion.p className="privacy-last-updated" variants={itemVariants}>
              {getTranslation('privacy.lastUpdated', language)}
            </motion.p>

            {sections.map((sectionKey) => (
              <motion.div
                className="privacy-section"
                variants={itemVariants}
                key={sectionKey}
              >
                <Markdown>
                  {getTranslation(`privacy.sections.${sectionKey}`, language)}
                </Markdown>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </motion.div>
  );
};

export default Privacy;
